// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
//       }

//       // hide(preventFocus = false) {
//       //   const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       //   if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//       //   //document.querySelectorAll('.quick-add__submit')classList.remove('change-text');
//       //  // document.querySelector('.change-text').classList.remove('change-text');
//       //    removeAllChangeTextClasses();
//       //   this.modalContent.innerHTML = '';
//       //   if (preventFocus) this.openedBy = null;
//       //   super.hide();
//       //   unlockQuickAddBodyScroll();
//       // }

//       hide(preventFocus = false) {
//       const cartNotification =
//         document.querySelector('cart-notification') ||
//         document.querySelector('cart-drawer');

//       if (cartNotification) {
//         cartNotification.setActiveElement(this.openedBy);
//       }

//       removeAllChangeTextClasses();

//       // IMPORTANT:
//       // Unlock scroll BEFORE modal hide
//       unlockQuickAddBodyScroll();

//       this.modalContent.innerHTML = '';

//       if (preventFocus) {
//         this.openedBy = null;
//       }

//       super.hide();
//     }
           
//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');
//         opener.classList.add('change-text');
        
//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
//             this.productElement.classList.forEach((classApplied) => {
//               if (classApplied.startsWith('color-') || classApplied === 'gradient')
//                 this.modalContent.classList.add(classApplied);
//             });
//             this.preventDuplicatedIDs();
//             this.removeDOMElements();
//             this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }

//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             this.removeGalleryListSemantic();
//             this.updateImageSizes();
//             this.preventVariantURLSwitching();
//             super.show(opener);
//             lockQuickAddBodyScroll();
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       setInnerHTML(element, html) {
//         element.innerHTML = html;

//         // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
//         element.querySelectorAll('script').forEach((oldScriptTag) => {
//           const newScriptTag = document.createElement('script');
//           Array.from(oldScriptTag.attributes).forEach((attribute) => {
//             newScriptTag.setAttribute(attribute.name, attribute.value);
//           });
//           newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
//           oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
//         });
//       }

//       preventVariantURLSwitching() {
//         const variantPicker = this.modalContent.querySelector('variant-selects');
//         if (!variantPicker) return;

//         variantPicker.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements() {
//         const pickupAvailability = this.productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = this.productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = this.productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs() {
//         const sectionId = this.productElement.dataset.section;
//         this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
//         this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
//           element.dataset.originalSection = sectionId;
//         });
//       }

//       removeGalleryListSemantic() {
//         const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes() {
//         const product = this.modalContent.querySelector('.product');
//         const desktopColumns = product.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }
//  function removeAllChangeTextClasses() {
//             const elements = document.querySelectorAll('.change-text');
//             elements.forEach(element => element.classList.remove('change-text'));
//         }

// function lockQuickAddBodyScroll() {
//   if (document.body.classList.contains('quick-add-scroll-locked')) return;

//   const scrollY = window.scrollY || window.pageYOffset;
//   document.body.dataset.quickAddScrollY = String(scrollY);
//   document.body.classList.add('quick-add-scroll-locked');
//   document.body.style.position = 'fixed';
//   document.body.style.top = `-${scrollY}px`;
//   document.body.style.left = '0';
//   document.body.style.right = '0';
//   document.body.style.width = '100%';
// }

// function unlockQuickAddBodyScroll() {
//   if (!document.body.classList.contains('quick-add-scroll-locked')) return;

//   const scrollY = parseInt(document.body.dataset.quickAddScrollY || '0', 10);
//   document.body.classList.remove('quick-add-scroll-locked');
//   document.body.style.position = '';
//   document.body.style.top = '';
//   document.body.style.left = '';
//   document.body.style.right = '';
//   document.body.style.width = '';
//   delete document.body.dataset.quickAddScrollY;
//   window.scrollTo(0, scrollY);
// }

// document.addEventListener('click', function (e) {

//   // Overlay close
//   if (
//     e.target.matches('.quick-add-modal__toggle') ||
//     e.target.matches('.modal-overlay')
//   ) {
//     unlockQuickAddBodyScroll();
//   }

// });

// document.addEventListener('keyup', function (e) {

//   // ESC close
//   if (e.key === 'Escape') {
//     unlockQuickAddBodyScroll();
//   }

// });


if (!customElements.get('quick-add-modal')) {

  customElements.define(
    'quick-add-modal',

    class QuickAddModal extends ModalDialog {

      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {

        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(this.openedBy);
        }

        removeAllChangeTextClasses();

        // IMPORTANT
        // Unlock BEFORE hide animation
        unlockQuickAddBodyScroll();

        this.modalContent.innerHTML = '';

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {

        opener.setAttribute('aria-disabled', true);

        opener.classList.add('loading');

        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        opener.classList.add('change-text');

        fetch(opener.getAttribute('data-product-url'))

          .then((response) => response.text())

          .then((responseText) => {

            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            this.productElement =
              responseHTML.querySelector('section[id^="MainProduct-"]');

            this.productElement.classList.forEach((classApplied) => {

              if (
                classApplied.startsWith('color-') ||
                classApplied === 'gradient'
              ) {
                this.modalContent.classList.add(classApplied);
              }

            });

            this.preventDuplicatedIDs();

            this.removeDOMElements();

            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();

            this.updateImageSizes();

            this.preventVariantURLSwitching();

            super.show(opener);

            // IMPORTANT
            // Delay body lock slightly
            requestAnimationFrame(() => {
              lockQuickAddBodyScroll();
            });

          })

          .finally(() => {

            opener.removeAttribute('aria-disabled');

            opener.classList.remove('loading');

            opener
              .querySelector('.loading__spinner')
              ?.classList.add('hidden');

          });

      }

      setInnerHTML(element, html) {

        element.innerHTML = html;

        // Re-execute scripts
        element.querySelectorAll('script').forEach((oldScriptTag) => {

          const newScriptTag = document.createElement('script');

          Array.from(oldScriptTag.attributes).forEach((attribute) => {

            newScriptTag.setAttribute(
              attribute.name,
              attribute.value
            );

          });

          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );

          oldScriptTag.parentNode.replaceChild(
            newScriptTag,
            oldScriptTag
          );

        });

      }

      preventVariantURLSwitching() {

        const variantPicker =
          this.modalContent.querySelector('variant-selects');

        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {

        const pickupAvailability =
          this.productElement.querySelector('pickup-availability');

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          this.productElement.querySelector('product-modal');

        if (productModal) {
          productModal.remove();
        }

        const modalDialog =
          this.productElement.querySelectorAll('modal-dialog');

        if (modalDialog) {
          modalDialog.forEach((modal) => modal.remove());
        }

      }

      preventDuplicatedIDs() {

        const sectionId = this.productElement.dataset.section;

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );

        this.productElement
          .querySelectorAll('variant-selects, product-info')
          .forEach((element) => {

            element.dataset.originalSection = sectionId;

          });

      }

      removeGalleryListSemantic() {

        const galleryList =
          this.modalContent.querySelector('[id^="Slider-Gallery"]');

        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => {

            li.setAttribute('role', 'presentation');

          });

      }

      updateImageSizes() {

        const product =
          this.modalContent.querySelector('.product');

        const desktopColumns =
          product.classList.contains('product--columns');

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll('.product__media img');

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {

          mediaImageSizes =
            mediaImageSizes.replace('715px', '605px');

        } else if (product.classList.contains('product--small')) {

          mediaImageSizes =
            mediaImageSizes.replace('715px', '495px');

        }

        mediaImages.forEach((img) => {

          img.setAttribute('sizes', mediaImageSizes);

        });

      }

    }

  );

}

/* =========================================
   REMOVE CHANGE TEXT CLASSES
========================================= */

function removeAllChangeTextClasses() {

  const elements =
    document.querySelectorAll('.change-text');

  elements.forEach((element) => {

    element.classList.remove('change-text');

  });

}

/* =========================================
   BODY LOCK
========================================= */

function lockQuickAddBodyScroll() {

  if (
    document.body.classList.contains(
      'quick-add-scroll-locked'
    )
  ) {
    return;
  }

  const scrollY =
    window.scrollY || window.pageYOffset;

  document.body.dataset.quickAddScrollY =
    String(scrollY);

  document.body.classList.add(
    'quick-add-scroll-locked'
  );

  document.body.style.position = 'fixed';

  document.body.style.top = `-${scrollY}px`;

  document.body.style.left = '0';

  document.body.style.right = '0';

  document.body.style.width = '100%';

  document.body.style.overflow = 'hidden';
}

/* =========================================
   BODY UNLOCK
========================================= */

function unlockQuickAddBodyScroll() {

  const scrollY = parseInt(
    document.body.dataset.quickAddScrollY || '0',
    10
  );

  document.body.classList.remove(
    'quick-add-scroll-locked',
    'overflow-hidden'
  );

  document.body.style.position = '';

  document.body.style.top = '';

  document.body.style.left = '';

  document.body.style.right = '';

  document.body.style.width = '';

  document.body.style.overflow = '';

  delete document.body.dataset.quickAddScrollY;

  window.scrollTo(0, scrollY);
}

/* =========================================
   FORCE CLEANUP
========================================= */

const quickAddModal =
  document.querySelector('quick-add-modal');

if (quickAddModal) {

  const observer = new MutationObserver(() => {

    const isOpen =
      quickAddModal.hasAttribute('open');

    // Modal fully closed
    if (!isOpen) {

      unlockQuickAddBodyScroll();

    }

  });

  observer.observe(quickAddModal, {
    attributes: true,
    attributeFilter: ['open']
  });

}

/* =========================================
   ESC KEY SUPPORT
========================================= */

document.addEventListener('keyup', function (event) {

  if (event.key === 'Escape') {

    setTimeout(() => {

      unlockQuickAddBodyScroll();

    }, 50);

  }

});